export const normalizeText = (text = "") => {
  return text
    .toString()
    .normalize("NFD")                 // separa acentos
    .replace(/[\u0300-\u036f]/g, "")  // remove acentos
    .replace(/[^a-zA-Z0-9\s]/g, "")   // remove caracteres especiais
    .toLowerCase()
    .trim();
};
